var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.dataRef),function(ref){return _c('div',{key:ref,staticClass:"ml-2"},[_c('font-awesome-icon',{attrs:{"icon":"save"},on:{"click":function($event){return _vm.downloadMedia(ref)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }